/// <reference types="node" />
export var CLIENT_VERSION = "0.0.0-development";